export default {"src":"/_next/static/media/mobile_hero.20e91ae0.svg","height":378,"width":364};